<div class="container">
  <h4 class="title">{{ title }}</h4>
  <div *ngIf="mainContentInnerHtml" [innerHtml]="mainContentInnerHtml" class="main-content"></div>
  <div *ngIf="mainContentText" class="main-content">
    {{ mainContentText }}
  </div>
  <div class="action-button">
    <button class="ui button link-button" data-cy="tooltip-cta-button" (click)="onButtonClick()">
      {{ actionButtonText }}
    </button>
  </div>
</div>
